import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatPrice(amount: number) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'MAD',
  }).format(amount);
}

function getTimezone(): string {
  return import.meta.env.VITE_TIMEZONE || 'Africa/Casablanca';
}

const localTimeFormatter = () =>
  new Intl.DateTimeFormat('en-US', {
    timeZone: getTimezone(),
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });

const localTimeOffsetFormatter = () =>
  new Intl.DateTimeFormat('en-US', {
    timeZone: getTimezone(),
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    timeZoneName: 'shortOffset',
  });

export function formatTimeToLocal(utcTime: string): string {
  const [hours, minutes] = utcTime.split(':').map(Number);
  const d = new Date();
  d.setUTCHours(hours, minutes, 0, 0);
  return localTimeFormatter().format(d);
}

export function toUTCIso(localDateTime: string): string {
  if (!localDateTime) return '';
  return new Date(localDateTime).toISOString();
}

export function toDateTimeLocal(utcIso: string): string {
  if (!utcIso) return '';
  const date = new Date(utcIso);
  if (isNaN(date.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

export function formatTimeToUTC(localTime: string): string {
  const [hours, minutes] = localTime.split(':').map(Number);

  const d = new Date('2024-01-01T00:00:00Z');
  const parts = localTimeOffsetFormatter().formatToParts(d);
  const tzNamePart = parts.find((p) => p.type === 'timeZoneName');
  const offsetStr = tzNamePart?.value || 'GMT+1';
  const match = offsetStr.match(/GMT([+-]\d+)/);
  const offset = match ? parseInt(match[1]) : 1;

  let utcHours = (hours - offset) % 24;
  if (utcHours < 0) utcHours += 24;

  return `${String(utcHours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
